
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/gcs",
      function () {
        return require("private-next-pages/sources/gcs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/gcs"])
      });
    }
  